exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.hamburger[data-v-4e6f274c] {\n  display: inline-block;\n  vertical-align: middle;\n  width: 24px;\n  height: 24px;\n}\n.hamburger.is-active[data-v-4e6f274c] {\n  -webkit-transform: rotate(180deg);\n          transform: rotate(180deg);\n}\n", ""]);

// exports
